import { IconChevronsLeft, IconChevronsRight } from '@tabler/icons-react';
import { useLocation } from 'react-router-dom';
import { APP_ORG_REGEX } from '../AppSwitcherProvider';
import classes from './Sidebar.module.css';
import { SidebarAppSwitcher } from './SidebarAppSwitcher';
import { SidebarFooter } from './SidebarFooter';
import { SidebarNavItems } from './SidebarNavItems';
import { useSidebarContext } from './SidebarProvider';
import { SidebarUtilities } from './SidebarUtilities';

export const Sidebar = () => {
  const { expanded, mobileOpen, toggle, closeMobile } = useSidebarContext();
  const { pathname } = useLocation();

  // Only show sidebar on org paths
  if (!APP_ORG_REGEX.test(pathname)) return null;

  return (
    <>
      {/* Mobile backdrop */}
      {mobileOpen && (
        <button
          type="button"
          className={classes.backdrop}
          onClick={closeMobile}
          aria-label="Close sidebar"
        />
      )}

      <aside
        className={`${classes.sidebar} ${!expanded ? classes.sidebarCollapsed : ''} ${mobileOpen ? classes.sidebarMobileOpen : ''}`}
      >
        <SidebarAppSwitcher />
        <div className={classes.divider} />
        <SidebarNavItems />
        <div className={classes.divider} />
        <SidebarUtilities />
        <div style={{ flex: 1 }} />
        <SidebarFooter />

        {/* Collapse toggle — desktop only */}
        <button
          type="button"
          className={classes.collapseBtn}
          onClick={toggle}
          aria-label={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
        >
          {expanded ? (
            <IconChevronsLeft size={18} />
          ) : (
            <IconChevronsRight size={18} />
          )}
        </button>
      </aside>
    </>
  );
};
